import sourceData from './sourceData'

const itemIdToSource = sourceData
  .map(({name, items}) => items.map(item => [item, name]))
  .reduce((acc, i) => [...acc, ...i], [])
  .reduce((acc, [id, name]) => {
    if (acc[id]) {
      acc[id].push(name)
    } else acc[id] = [name]
    return acc
  }, {})

export function getSources (itemId) {
  return itemIdToSource[itemId]
}



// WEBPACK FOOTER //
// ./src/domain/Source.js